import { Chip } from '@mui/material'
import { useIntl } from 'react-intl'
import messages from './messages'
import { VerifiedDomainStatus } from './types'

const StatusChip = ({ status }: { status: VerifiedDomainStatus }) => {
  const { formatMessage } = useIntl()

  switch (status) {
    case VerifiedDomainStatus.Verified:
      return <Chip size='small' color='success' label={formatMessage(messages.statusVerified)} />
    case VerifiedDomainStatus.Failed:
      return <Chip size='small' color='error' label={formatMessage(messages.statusFailed)} />
    case VerifiedDomainStatus.Pending:
    default:
      return <Chip size='small' color='warning' label={formatMessage(messages.statusPending)} />
  }
}

export default StatusChip
